/**
 * `useMergeRefs` is a helper for using refs while preserving existing refs if
 * they exist.
 */
import * as React from "react"

const setRefs = <T>(ref: React.Ref<T>, value: T | null) => {
  if (typeof ref === "function") {
    ref(value)
    return
  }
  ;(ref as React.MutableRefObject<any>).current = value
}

/**
 *
 * @param refs A list of React.Refs
 */
const useMergeRefs = <T>(...refs: React.Ref<T>[]) =>
  React.useMemo(() => {
    const filteredRefs = refs.filter(Boolean)
    if (filteredRefs.length === 0) return null
    if (filteredRefs.length === 1) return filteredRefs[0]
    return (value: T) =>
      filteredRefs.forEach(ref => {
        setRefs(ref, value)
      })
  }, [refs])

export default useMergeRefs
